import styled from "@emotion/styled";

export const LineItemWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray50,
	padding: "16px",
	gap: "16px",
	display: "flex",
	flexDirection: "column",
	border: `1px solid ${theme.palette.divider}`
}));

export const LineItemDetails = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "5fr 1fr 1fr 1fr 1fr 1fr",
	gap: "24px",
	[theme.breakpoints.down("md")]: {
		gap: "0px",
		display: "flex",
		flexDirection: "column"
	}
}));

export const LineItemDetailsSkuNumberContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: "16px"
}));

export const LineItemDetailsNumber = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.secondary
}));

export const LineItemDetailsSkuContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column"
}));

export const LineItemDetailsSkuLabel = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main
}));

export const LineItemDetailsSkuDescription = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const LineItemDetailsItemContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "4px 0",
	[theme.breakpoints.down("md")]: {
		flexDirection: "row",
		gap: "8px"
	}
}));

export const LineItemDetailsItemLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const LineItemModificationsContainer = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "4fr 1fr",
	[theme.breakpoints.down("md")]: {
		display: "flex",
		flexDirection: "column"
	}
}));

export const LineItemModificationsSkuNumberContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	paddingBottom: "8px",
	gap: "12px"
}));

export const LineItemModificationsNumber = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const LineItemModificationsSkuLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const LineItemModificationsSkuDescription = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const LineItemModificationsPricesContainer = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "1.2fr 1fr",
	[theme.breakpoints.down("md")]: {
		display: "flex",
		gap: "12px"
	}
}));
